export default {
    fileNotFound: 'File not found in the OneDrive or SharePoint folder for this user. Try logging in with another account.!'
}